// extracted by mini-css-extract-plugin
module.exports = {"button":"button-346e9355","primary":"primary-a2cad8ba","animation":"animation-32575d31"};